import { createContext, useCallback, useContext, useState } from 'react'

const API_ENVIRONMENT_STORAGE_KEY = 'adminApiEnvironment'

const normalizeBaseUrl = (baseUrl) => String(baseUrl || '').replace(/\/+$/, '')

const environments = {
  production: {
    label: 'Production',
    baseUrl: normalizeBaseUrl(process.env.REACT_APP_BASE_URL),
  },
  development: {
    label: 'Development',
    baseUrl: normalizeBaseUrl(
      process.env.REACT_APP_DEV_BASE_URL || 'https://dev-api.fortunefoes.com',
    ),
  },
}

const getStoredEnvironment = () => {
  const environment = localStorage.getItem(API_ENVIRONMENT_STORAGE_KEY)
  return Object.prototype.hasOwnProperty.call(environments, environment) ? environment : 'production'
}

export const getApiBaseUrl = () => environments[getStoredEnvironment()].baseUrl
export const getApiEnvironment = () => getStoredEnvironment()

const ApiEnvironmentContext = createContext(null)

export const ApiEnvironmentProvider = ({ children }) => {
  const [environment, setEnvironment] = useState(getStoredEnvironment)
  const [isEnvironmentChanging, setIsEnvironmentChanging] = useState(false)

  const setApiEnvironment = useCallback((nextEnvironment) => {
    if (!Object.prototype.hasOwnProperty.call(environments, nextEnvironment)) return

    localStorage.setItem(API_ENVIRONMENT_STORAGE_KEY, nextEnvironment)
    setIsEnvironmentChanging(true)
    setEnvironment(nextEnvironment)
  }, [])

  const finishEnvironmentChange = useCallback(() => setIsEnvironmentChanging(false), [])

  return (
    <ApiEnvironmentContext.Provider
      value={{
        environment,
        environmentLabel: environments[environment].label,
        isEnvironmentChanging,
        setApiEnvironment,
        finishEnvironmentChange,
      }}
    >
      {children}
    </ApiEnvironmentContext.Provider>
  )
}

export const useApiEnvironment = () => {
  const context = useContext(ApiEnvironmentContext)
  if (!context) throw new Error('useApiEnvironment must be used within ApiEnvironmentProvider')
  return context
}
